import React from 'react';
import { MapPin, Award, UserCheck, ShieldCheck, AlertCircle } from 'lucide-react';
import { compliancePoints } from '../data/mock';

const iconMap = {
  MapPin: MapPin,
  Award: Award,
  UserCheck: UserCheck,
  ShieldCheck: ShieldCheck,
};

const ComplianceSection = () => {
  return (
    <section id="compliance" className="py-24 md:py-32 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="inline-block text-cyan-400 text-sm font-semibold tracking-wider uppercase mb-4">
            Compliance & Responsibility
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Responsible Gaming Standards
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            Our commitment to compliance and responsible gaming practices is fundamental to everything we build.
          </p>
        </div>

        {/* Compliance Points */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {compliancePoints.map((point) => {
            const Icon = iconMap[point.icon];
            return (
              <div
                key={point.id}
                className="group text-center p-6 rounded-2xl bg-slate-900/50 border border-slate-800 hover:border-cyan-500/30 transition-all duration-300"
              >
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-slate-800 text-cyan-400 mb-5 group-hover:bg-cyan-500/10 transition-colors duration-300">
                  <Icon size={32} />
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-white mb-2">
                  {point.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed">
                  {point.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Legal Disclaimer Box */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-slate-900 border border-amber-500/30 rounded-xl p-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <AlertCircle className="w-6 h-6 text-amber-400" />
              </div>
              <div>
                <h4 className="text-amber-400 font-semibold mb-2">
                  Important Notice
                </h4>
                <p className="text-slate-400 text-sm leading-relaxed">
                  Mind Flex Games operates exclusively in jurisdictions where skill-based gaming is legally permitted. 
                  Our platforms are not available where prohibited by law. All participants must meet applicable 
                  age requirements in their respective jurisdictions. We are committed to responsible gaming 
                  principles and user protection standards.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplianceSection;
